// Native
import { Route, Routes as BrowserRoutes } from "react-router-dom"

// Custom
import { UI } from "components"
import List from "./list"
import Order from "./order"

export default function Orders(){

    return(
    <>
    <UI.Header title="Pedidos" />
            
    <BrowserRoutes>
        <Route path="/:id" element={<Order />} />
        <Route index element={<List />} />
    </BrowserRoutes>
    </>
    )
}